import { inject, Injectable } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { ApiService } from '../../core/api.service';
import { ApiResponse } from '../../models/api-response.model';

@Injectable({ providedIn: 'root' })
export class UsersService {
  private readonly apiService = inject(ApiService);

  list(): Observable<any[]> {
    const url = `users`;
    return this.apiService
      .get<ApiResponse<any[]>>(url, { page: 1, per_page: 100 })
      .pipe(map((response) => response.data));
  }

  getById(id: string): Observable<any> {
    return this.apiService.get<ApiResponse<any>>(`users/${id}`).pipe(map((r) => r.data));
  }
}
